'use strict';

var index = require('./animation/index.cjs');
var exit = require('./animation/exit.cjs');

const animations = {
    animation: {
        Feature: index.AnimationFeature,
    },
    exit: {
        Feature: exit.ExitAnimationFeature,
    },
};

exports.animations = animations;
//# sourceMappingURL=animations.cjs.map
